/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal, Popover } from 'antd';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { ActionDeleteAppConfig, ActionGetAppConfigList } from '../../store/Actions/AppConfigAction';
import { ResponsiveComponent, generateQueryString, trimText } from '../../utils/functions';
import Header from '../../components/Header';
import TableColumnSearch from '../../components/Input/TableColumnSearch';
import Sidebar from '../../components/Sidebar';
import { CustomTable } from '../../components/Table';
import { plusicon, refreshicon } from '../../components/imagepath';
import { matchPermissions } from '../../utils/Permission';
import useCommonFilters from '../../hooks/useCommonFilters';
const { confirm } = Modal;

const AppConfig = () => {
  const { appConfig, loader } = useSelector(state => state?.appConfig);
  const [showArrow, setShowArrow] = useState(true);
  const [Refresh, setRefresh] = useState(false);
  const [arrowAtCenter, setArrowAtCenter] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const pageSize = 10;
  const dispatch = useDispatch();
  const location = useLocation();
  const { userDetails } = useSelector(state => state?.auth);
  const Size = ResponsiveComponent();

  // Use common filters with allowed filter keys and legacy function support
  const { filters, updateFilters, clearAllFilters, currentPage, handleSearch, handleReset } =
    useCommonFilters(location, ['key', 'value'], { setSearchText, setSearchedColumn });

  const mergedArrow = useMemo(() => {
    if (arrowAtCenter) return { pointAtCenter: true };
    return showArrow;
  }, [showArrow, arrowAtCenter]);

  const matchPermissionsForUser = matchPermissions(userDetails);
  const canUpdate = matchPermissionsForUser('app-config.update');
  const canDelete = matchPermissionsForUser('app-config.delete');
  const canCerate = matchPermissionsForUser('app-config.create');

  const content = item => (
    <div className="">
      {canUpdate && (
        <Button className="m-2" onClick={() => EditList(item?.id)}>
          Edit
        </Button>
      )}
      {canDelete && <Button onClick={() => showDeleteConfirm(item)}>Delete</Button>}
    </div>
  );

  const column = [
    {
      title: 'Sr',
      dataIndex: 'sr',
      key: 'Sr',
      render: (text, record, index) => {
        const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
        return <span>{calculatedIndex}</span>;
      },
    },
    {
      title: 'Keys',
      dataIndex: 'key',
      render: (text, record) => <span>{text}</span>,
      ...TableColumnSearch({
        dataIndex: 'key',
        setSearchText,
        setSearchedColumn,
        handleReset,
        handleSearch,
        filtered: filters?.key,
      }),
      sorter: (a, b) => a.key.length - b.key.length,
    },
    {
      title: 'Values',
      dataIndex: 'value',
      render: (text, record) => (
        <div className="app-config-boldText">
          {trimText(text, Size === 'phone' || Size === 'tablet' ? 20 : 100)}
        </div>
      ),
      ...TableColumnSearch({
        dataIndex: 'value',
        setSearchText,
        setSearchedColumn,
        handleReset,
        handleSearch,
        filtered: filters?.value,
      }),
    },
    {
      title: !canUpdate && !canDelete ? null : 'Action',
      dataIndex: 'key',
      key: 'key',
      render: (text, record, num) => {
        if (!canUpdate && !canDelete) {
          return null;
        } else {
          return (
            <Popover
              placement="left"
              title={text}
              content={() => content(record)}
              arrow={mergedArrow}
            >
              <Button type="dashed">• • •</Button>
            </Popover>
          );
        }
      },
    },
  ];

  useEffect(() => {
    const hasOtherFilters = filters?.key || filters?.value;

    const queryStr = hasOtherFilters
      ? generateQueryString(['value', filters?.value], ['key', filters?.key])
      : generateQueryString(['page', currentPage]);

    dispatch(ActionGetAppConfigList(queryStr));
    setRefresh(false);
  }, [Refresh, currentPage, filters?.key, filters?.value, dispatch]);

  const handlePageChange = page => {
    updateFilters({ page });
  };

  const EditList = id => {
    window.location.href = `/app-config/add-appconfig?update=true&&id=${id}&&page=${currentPage}`;
  };

  const showDeleteConfirm = item => {
    confirm({
      title: `Are you sure delete this ${item?.key} Key?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      zIndex: 1200,
      centered: true,
      onOk() {
        dispatch(
          ActionDeleteAppConfig('/' + item?.id, Res => {
            if (Res?.statusCode === 200) {
              setRefresh(true);
            }
          })
        );
      },
      onCancel() {
        return
      },
    });
  };

  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="expenses.html">App Config</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Add Configration</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table show-entire">
                    <div className="card-body">
                      {/* Table Header */}
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>App Configration List</h3>
                              <div className="doctor-search-blk">
                                <div className="add-group">
                                  {canCerate && (
                                    <Link
                                      to="/app-config/add-appconfig"
                                      className="btn btn-primary add-pluss ms-2"
                                    >
                                      <img src={plusicon} alt="#" />
                                    </Link>
                                  )}
                                  <Link
                                    onClick={() => window.location.reload()}
                                    className="btn btn-primary doctor-refresh ms-2"
                                  >
                                    <img src={refreshicon} alt="#" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /Table Header */}
                      <CustomTable
                        CurrentPageNum={currentPage}
                        OnChange={handlePageChange}
                        TotalPageList={appConfig?.totalDocs}
                        column={column}
                        dataSource={appConfig?.docs}
                        dataSourceLength={appConfig?.docs?.length}
                        pageSize={10}
                        loader={loader}
                        ShowHeader={true}
                        Header={<div className="staff-search-table"></div>}
                        key={'hi'}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default AppConfig;
